import { Flex, Skeleton } from 'antd'
import { BudgetCoinLoader } from 'src/pages/budget/components'

export const TableSkeleton = () => {
  const { Input } = Skeleton
  return (
    <Flex vertical gap={16}>
      <BudgetCoinLoader />
      <Input active style={{ width: '100%', height: 68 }} />
      <Flex justify="flex-end" gap={16}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Input active key={item} />
        ))}
      </Flex>
      <Input block active style={{ height: 230 }} />
    </Flex>
  )
}
